import Papa from 'papaparse';
import { DiskData, MergedFspSegment } from '../../types/turnFsp';
import { RecordValueWithSensograms } from '../../services/cache/idb';
import { getDiskNameFromPosition } from './utils';

export const exportFspWithTurnToCsv = (x: MergedFspSegment[], record: RecordValueWithSensograms) => {
  const filename = `${record.name}.timeseries.csv`;

  console.log('x is', x);
  var flattenX: number[][] = [];

  // union keys
  const allFspKeys: Set<string> = new Set();
  for (let i = 0; i < x.length; i++) {
    let segment = x[i];
    Object.keys(segment.fspSensorData).forEach((key) => allFspKeys.add(key));
  }

  console.log('allKeys', allFspKeys);

  for (let k = 0; k < x.length; k++) {
    let segment = x[k];
    let flattenX_k: number[][] = [];

    // insert new lines
    let turnId = segment.turnNumberID;
    segment.angleValues.forEach((a) => flattenX_k.push([turnId, a]));

    for (let spot of allFspKeys) {
      let val = segment.fspSensorData[spot] as number[];
      val.forEach((v, i) => flattenX_k[i].push(v));
    }
    flattenX.push(...flattenX_k);
  }

  let allKeys = ['turn (deg)', 'angle'];
  allKeys.push(...allFspKeys);
  const csv = Papa.unparse({ fields: allKeys, data: flattenX });
  var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  var csvURL = window.URL.createObjectURL(csvData);

  var csvLink = document.createElement('a');
  csvLink.href = csvURL;
  csvLink.setAttribute('download', filename);
  csvLink.click();
};

export const exportDiskDiameterResultsToCsv = (x: DiskData[], record: RecordValueWithSensograms, diskNames: string[]) => {
  const filename = `${record.name}.results.csv`;

  console.log('x is', x);
  var rows: string[][] = [];

  for (let k = 0; k < x.length; k++) {
    let res_i = x[k];
    const diskName = getDiskNameFromPosition(diskNames, res_i.disk);
    let row = [new Date(record.absoluteTimestamp).toString(), record.key, record.name || '', res_i.lap.toString(), res_i.disk.toString(), diskName, res_i.diameter.toFixed(1), res_i.angle_l.toFixed(2), res_i.angle_r.toFixed(2)];

    rows.push(row);
  }

  let allKeys = ['Datetime', 'Record ID', 'Record Name', 'Lap number', 'Disk Position', 'Disk Name', 'Diameter value (mm)', 'Angle 1 (°)', 'Angle 2 (°)'];
  const csv = Papa.unparse({ fields: allKeys, data: rows });
  var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  var csvURL = window.URL.createObjectURL(csvData);

  var csvLink = document.createElement('a');
  csvLink.href = csvURL;
  csvLink.setAttribute('download', filename);
  csvLink.click();
};
